import React from 'react';
import is from 'is_js';
import BaseSessionNav from 'components/BaseSessionNav';
import PropTypes from 'prop-types';
import QuickSummary from 'components/QuickSummary';
import { connect } from 'omni-common-ui';
import { getProgressTestPlanFromIndex } from 'data/ProgressTestsPlan/accessors';
import { actions as UiState } from 'data/UiState';
import { actions as Group } from 'containers/Group';

class ProgressTestSessionNav extends BaseSessionNav {
  _hasNext() {
    return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
  }

  _hasPrevious() {
    return this.props.currentProgressTestIndex > 0;
  }

  _hasNextUnit() {
    return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
  }

  _hasPreviousUnit() {
    return this.props.currentProgressTestIndex > 0;
  }

  _getHeadingText() {
    return this.props.currentGroupName;
  }

  _getPreviousUnitText() {
    return `< UNIT ${this.props.currentProgressTestIndex}`;
  }

  _getNextUnitText() {
    return `UNIT ${this.props.currentProgressTestIndex + 2} >`;
  }

  _getAdditionalChildren() {
    return <h2>
      <QuickSummary type={QuickSummary.Type.progressTest}
          entityId={this.props.currentProgressTestId}
          isSSV3Group={this.props.isSSV3Group} />
    </h2>;
  }

  render() {
    if (this.props.currentProgressTestId) {
      return super.render();
    }
    return null;
  }
}

ProgressTestSessionNav.propTypes = Object.assign({
  isSSV3Group: PropTypes.bool,
  currentGroupName: PropTypes.string,
  currentProgressTestIndex: PropTypes.number.isRequired,
  currentProgressTestId: PropTypes.string,
  progressTestCount: PropTypes.number.isRequired,
  onNextClicked: PropTypes.func,
  onPreviousClicked: PropTypes.func,
  getProgressTestPlanFromIndex: PropTypes.func,
  isUnitQuiz: PropTypes.bool.isRequired,
}, BaseSessionNav.propTypes);

function mapStateToProps(state, ownProps) {
  const { groupId, progressTestIndex } = ownProps.params;
  if (! progressTestIndex) return;
  const { buildRoute, routes, isUnitQuiz } = ownProps;
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const progressTestsPlans = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  const progressTestsPlan = progressTestsPlans &&
    progressTestsPlans.data &&
    progressTestsPlans.data.filter((ptp) => ptp.isUnitQuiz === isUnitQuiz);
  const currentProgressTestPlan =
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz);
  if (group && progressTestsPlan) {
    const currentRoute = routes[routes.length - 1];
    return {
      isSSV3Group: !! Group.isSSV3Group(state, groupId),
      currentProgressTestId: currentProgressTestPlan.id,
      currentGroupName: group.name,
      progressTestCount: progressTestsPlan.size,
      currentProgressTestIndex: progressTestIndex,
      nextSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute),
      previousSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex,
        currentRoute,
        buildRoute,
        true),
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

function getNextProgressTestLinkHref(index, currentRoute, buildRoute, previous = false) {
  const progressTestIndex = Number.parseInt(index, 10) + (previous ? - 1 : 1);
  const { sessionNavConfig } = currentRoute;
  const newRouteParams = {
    progressTestIndex,
  };
  // this allows us to leave `edit` mode in the day view when displaying a new session
  if (is.object(sessionNavConfig) && is.string(sessionNavConfig.setModeOnNavigate)) {
    newRouteParams.mode = sessionNavConfig.setModeOnNavigate;
  }
  const tempRoute = buildRoute(newRouteParams);
  return buildRoute(`${tempRoute}`);
}

export default connect(mapStateToProps, null)(ProgressTestSessionNav);



// WEBPACK FOOTER //
// ./components/ProgressTestSessionNav/index.jsx